export const difficultyFilterOptions = [
  'introductory',
  'beginner',
  'moderate',
  'intermediate',
  'advanced'
]

export const intensityFilterOptions = [
  {
    level: 1,
    caption:
      'Ideal for those looking for a slower-paced, chill, or more restorative style of class. You’ll leave feeling calm, relaxed, and at ease.'
  },
  {
    level: 2,
    caption:
      'Great for those who want to move at a slow to moderate pace. Classes within this level vary from feel-good flows to entry-level strength training. You’ll feel comfortably challenged and explore a more dynamic range of movement.'
  },
  {
    level: 3,
    caption:
      'This is the best option for those looking to amp up the sweat factor. You’ll get your heart rate up, test your endurance, and challenge your limits with faster-paced movement and exercises.'
  },
  {
    level: 4,
    caption:
      'These classes are designed to test your limits to the max. You’ll move at a fast pace to push yourself to your peak, increase your heart rate, and accelerate your breathing. Prepare to discover untapped levels of strength and endurance.'
  }
]
